<div>
   <div class="spinner-container" *ngIf="requestRunning">
        <mat-spinner></mat-spinner>
  </div>
  <ngx-spinner bdColor = "rgba(39,58,125,0.8)" size = "medium" color = "#fff" type = "ball-clip-rotate-multiple" [fullScreen] = "false" [name]="'Mktpcfg'">
  </ngx-spinner>
  <h3>Configurar Request</h3>
  <p>{{statusMessage}}</p>
  <div class="input-group">
    <label>Service Name/URL:</label>
    <input [(ngModel)]="data.requestConfig.serviceName" placeholder="URL ou Nome do Serviço">
  </div>
  <div class="input-group">
    <label>URL Type:</label>
    <input [(ngModel)]="data.requestConfig.urlType" placeholder="Deixe vazio se serviceName for URL">
  </div>
  <div class="input-group">
    <label>Método:</label>
    <select [(ngModel)]="data.requestConfig.method">
      <option value="GET">GET</option>
      <option value="POST">POST</option>
      <option value="PUT">PUT</option>
      <option value="DELETE">DELETE</option>
    </select>
  </div>
  <div class="input-group">
    <label>Parâmetros:</label>
    <input [(ngModel)]="data.requestConfig.params" placeholder="?getFullShopeeParams({@CODECOMPANY},...)">
  </div>
  <div class="input-group">
    <label>Body:</label>
    <textarea [(ngModel)]="data.formula" placeholder="Fórmula ou Valor do Body (ex.: JSON ou XML)" rows="5"></textarea>
    <button mat-icon-button (click)="testFormula('B')" title="Testar Fórmula">
      <mat-icon>play_arrow</mat-icon>
    </button>
  </div>
  <div class="input-group">
    <label>Header:</label>
    <textarea [(ngModel)]="data.requestConfig.headerFormula" placeholder="Fórmula ou Valor do Header" rows="3"></textarea>
    <button mat-icon-button (click)="testFormula('H')" title="Testar Fórmula">
      <mat-icon>play_arrow</mat-icon>
    </button>
  </div>
  <div class="input-group">
    <label>Código Marketplace:</label>
    <input [(ngModel)]="data.requestConfig.codeMktp" placeholder="Ex.: 47">
  </div>
  <button mat-raised-button (click)="save()">Salvar</button>
  <button mat-raised-button (click)="testRequest()" style="margin-left: 8px;">Testar</button>


  <div class="json-preview">
    <div style="display: flex; align-items: center; justify-content: space-between;">
      <h3>JSON Gerado</h3>
      <button mat-icon-button (click)="copyJson()" title="Copiar JSON">
        <mat-icon>content_copy</mat-icon>
      </button>
    </div>
   <pre>{{ getFormattedJSON() }}</pre>
  </div>

 

</div>